// Szare pulsujące miejsce na dane, które się jeszcze wczytują (styl shadcn/ui).
// Rozmiar i kształt przez className, np. <Skeleton className="h-4 w-40" />.
import { cn } from "../../lib/utils";

export const Skeleton = ({ className }: { className?: string }) => (
  <div aria-hidden className={cn("animate-pulse rounded-[6px] bg-[var(--sc-border)]", className)} />
);

// Kilka linii tekstu o malejącej długości
export const SkeletonLines = ({ lines = 3, className }: { lines?: number; className?: string }) => (
  <div className={cn("flex flex-col gap-2", className)}>
    {Array.from({ length: lines }, (_, i) => (
      <div key={i} style={{ width: `${100 - i * 15}%` }}>
        <Skeleton className="h-3" />
      </div>
    ))}
  </div>
);

// Dla czytników ekranu: jeden komunikat zamiast wielu pustych bloków
export const LoadingRegion = ({ label = "Wczytywanie", children, className }: { label?: string; children: React.ReactNode; className?: string }) => (
  <div role="status" aria-busy="true" aria-label={label} className={className}>
    {children}
  </div>
);

// Formularz: etykieta + pole (listy FUL i CL)
export const FormFieldsSkeleton = ({ fields = 6 }: { fields?: number }) => (
  <LoadingRegion label="Wczytywanie formularza" className="space-y-4">
    {Array.from({ length: fields }, (_, i) => (
      <div key={i}>
        <Skeleton className="h-2.5 w-28 mb-2" />
        <Skeleton className={i % 3 === 1 ? "h-16 w-full rounded-lg" : "h-9 w-full rounded-lg"} />
      </div>
    ))}
  </LoadingRegion>
);

// Wiersze tabeli lub listy (rejestry, listy wizyt i issues)
export const RowsSkeleton = ({ rows = 6, className }: { rows?: number; className?: string }) => (
  <LoadingRegion label="Wczytywanie" className={cn("rounded-[12px] border border-[var(--sc-border)] bg-[var(--sc-surface)] overflow-hidden", className)}>
    {Array.from({ length: rows }, (_, i) => (
      <div key={i} className="flex items-center gap-4 px-4 py-3 border-b border-[var(--sc-border)] last:border-b-0">
        <Skeleton className="h-3 w-[22%]" />
        <Skeleton className="h-3 w-[30%]" />
        <Skeleton className="h-3 w-[12%]" />
        <Skeleton className="h-5 w-20 rounded-full ml-auto" />
      </div>
    ))}
  </LoadingRegion>
);
